export default "__VITE_ASSET__ae33b2e6__"